import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { MatDialogModule, MatIconModule } from '@angular/material';
import { BrowserModule } from '@angular/platform-browser';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { LciAuthModule } from '@lciapps/auth';
import { DynamicTranslationsModule } from '@lciapps/dynamic-translations';
import {
  AlertService,
  InitModule,
  SharedModule,
  TranslationModule
} from '@lciapps/lci-core';
import { Angulartics2Module } from 'angulartics2';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CONFIG, translationConfig } from './app.config';
import { ApplicationAlertsComponent } from './application-alerts/application-alerts.component';
import { AuthNavComponent } from './auth-nav.component';
import { FeatureRoutesModule } from './feature-routes.module';
import { MetricsService } from './features/activities/metrics.service';
import { ActivitiesSharedModule } from './features/activities/shared/activities-shared.module';
import { ActivitiesService } from './features/activities/shared/services/activities.service';
import { ReportingService } from './features/activities/shared/services/reporting.service';
import { GlobalErrorHandler } from './global-error-handler';
import { GoogleAnalyticsService } from './google-analytics.service';
import { AnalyticsService } from './google-analytics/analytics.services';
import { DataLayerCustomDimensionsService } from './google-analytics/data-layer-custom-dimensions.service';
// import { AuthTimeInterceptor } from './http-interceptors/auth-time-interceptor';
import { HttpErrorInterceptor } from './http-interceptors/error-interceptor';
import { LinkBarComponent } from './link-bar.component';
import { PipesCommonModule } from './pipes/pipes.module';
import { ProtectedComponent } from './protected/protected.component';
import { ActivitiesDisclaimerComponent } from './root/activities-disclaimer/activities-disclaimer.component';
import { AlertsComponent } from './root/alerts.component';
import { AuthCallbackComponent } from './root/auth-callback.component';
import { CapsDialogComponent } from './root/caps-dialog.component';
import { FooterComponent } from './root/footer.component';
import { HomeComponent } from './root/home/home.component';
import { IeNoSupportComponent } from './root/ie-no-support/ie-no-support.component';
import { MemberGuard } from './root/member.guard';
import { NonMemberComponent } from './root/non-member.component';
import { RedirectComponent } from './root/redirect.component';
import { RootComponent } from './root/root.component';
import { SignoutComponent } from './root/signout.component';
import { SpinnerComponent } from './root/spinner/spinner.component';
import { SpinnerService } from './root/spinner/spinner.service';
import { SsoSamlComponent } from './root/sso-saml.component';
import { ScrollService } from './scroll.service';

@NgModule({
  imports: [
    ActivitiesSharedModule,
    BrowserModule,
    TranslationModule.forRoot(translationConfig),
    LciAuthModule.forRoot(CONFIG),
    AppRoutingModule,
    SharedModule,
    RouterModule,
    NoopAnimationsModule,
    InitModule,
    FeatureRoutesModule,
    MatIconModule,
    MatDialogModule,
    Angulartics2Module,
    Angulartics2Module.forRoot(),
    DynamicTranslationsModule.forRoot(environment, translationConfig),
    PipesCommonModule
  ],
  declarations: [
    AppComponent,
    AuthCallbackComponent,
    NonMemberComponent,
    ProtectedComponent,
    RootComponent,
    SignoutComponent,
    AuthNavComponent,
    RedirectComponent,
    FooterComponent,
    LinkBarComponent,
    AlertsComponent,
    SsoSamlComponent,
    HomeComponent,
    SpinnerComponent,
    IeNoSupportComponent,
    CapsDialogComponent,
    ApplicationAlertsComponent,
    ActivitiesDisclaimerComponent,
  ],
  entryComponents: [AlertsComponent, IeNoSupportComponent, CapsDialogComponent, ActivitiesDisclaimerComponent],
  providers: [
    AlertService,
    MemberGuard,
    ScrollService,
    ActivitiesService,
    ReportingService,
    MetricsService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: AuthTimeInterceptor,
    //   multi: true
    // },
    SpinnerService,
    GoogleAnalyticsService,
    DataLayerCustomDimensionsService,
    AnalyticsService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
